export var UPDATE = 'REDUX_ORM_UPDATE';
export var DELETE = 'REDUX_ORM_DELETE';
export var CREATE = 'REDUX_ORM_CREATE';
export var FILTER = 'REDUX_ORM_FILTER';
export var EXCLUDE = 'REDUX_ORM_EXCLUDE';
export var ORDER_BY = 'REDUX_ORM_ORDER_BY';
export var SUCCESS = 'SUCCESS';
export var FAILURE = 'FAILURE';